import { SplashScreen } from "@inventory/components/common/SplashScreen";

import React from "react";
import { Navigate, Outlet } from "react-router-dom";

import { useAuthState } from "igfd-commons/src/auth";

/**
 * Layout for unauthenticated pages (login). Full-height; the login page owns
 * its own background and centering so it can render full-bleed (per the Product
 * SOT). Forgotten-password is a modal sheet shown over the login screen.
 */
export const UnauthenticatedLayout = () => {
  const { loading, user } = useAuthState();

  if (loading) {
    return <SplashScreen />;
  }

  if (user) {
    return <Navigate to="/" />;
  }

  return <Outlet />;
};
